import React from "react";

export default ({size = 1}) => {
    return (<div style={{height: 8 * size}}/>)
}